<template>
  <div class="dashboard">
    <div class="dashboard-header">
      <h2>仪表盘</h2>
      <p>欢迎回来，{{ userInfo.account || '用户' }}</p>
    </div>

    <div class="dashboard-cards">
      <div class="card today-cost">
        <div class="card-icon">
          <img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="今日消耗" />
        </div>
        <div class="card-content">
          <div class="card-label">今日消耗</div>
          <div class="card-value">
            <span class="currency">¥</span>
            <span class="amount">{{ todayCost }}</span>
          </div>
          <div class="card-trend">
            <span class="trend-up">↑ 12.5%</span>
            <span class="trend-text">较昨日</span>
          </div>
        </div>
      </div>

      <div class="card account-balance">
        <div class="card-icon">
          <img src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDZC2.png" alt="账号余额" />
        </div>
        <div class="card-content">
          <div class="card-label">账号余额</div>
          <div class="card-value">
            <span class="currency">¥</span>
            <span class="amount">{{ userInfo.money || '0.00' }}</span>
          </div>
          <div class="card-actions">
            <button class="btn-recharge" @click="goRecharge">立即充值</button>
          </div>
        </div>
      </div>

      <div class="card api-keys">
        <div class="card-icon">
          <img src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDSC2.png" alt="密钥数量" />
        </div>
        <div class="card-content">
          <div class="card-label">密钥数量</div>
          <div class="card-value">
            <span class="amount">{{ apiKeyCount }}</span>
            <span class="unit">个</span>
          </div>
          <div class="card-actions">
            <button class="btn-manage" @click="goApps">管理密钥</button>
          </div>
        </div>
      </div>

      <div class="card total-cost">
        <div class="card-icon">
          <img src="https://hmcdn.1laigc.com/hm-avatar/Menu-XFRW.png" alt="消耗总计" />
        </div>
        <div class="card-content">
          <div class="card-label">消耗总计</div>
          <div class="card-value">
            <span class="currency">¥</span>
            <span class="amount">{{ totalCost }}</span>
          </div>
          <div class="card-trend">
            <span class="trend-text">累计消耗</span>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="recent-activities">
        <div class="activities-header">
          <h3>最近活动</h3>
          <span class="view-all" @click="goToExpend">查看全部</span>
        </div>
        <div class="activity-list">
          <div class="activity-item" v-for="(activity, index) in recentActivities" :key="index">
            <div class="activity-icon" :class="activity.type">
              <img v-if="activity.type === 'consume'" src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="消耗" />
              <img v-else-if="activity.type === 'recharge'" src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDZC2.png" alt="充值" />
              <img v-else src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDSC2.png" alt="密钥" />
            </div>
            <div class="activity-content">
              <div class="activity-title">{{ activity.title }}</div>
              <div class="activity-time">{{ activity.time }}</div>
            </div>
            <div class="activity-amount" :class="activity.type">
              {{ activity.amount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      userInfo: {},
      todayCost: '0.00',
      totalCost: '0.00',
      apiKeyCount: 0,
      recentActivities: [
        { type: 'consume', title: 'API调用消耗', time: '今天 14:30', amount: '-¥0.05' },
        { type: 'recharge', title: '账户充值', time: '今天 10:20', amount: '+¥100.00' },
        { type: 'consume', title: 'API调用消耗', time: '昨天 18:45', amount: '-¥0.12' },
        { type: 'api', title: '创建新密钥', time: '昨天 15:30', amount: '' },
        { type: 'consume', title: 'API调用消耗', time: '昨天 09:15', amount: '-¥0.08' }
      ]
    }
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await this.$api.getUserInfo.get()
        if (res.code === 200) {
          this.userInfo = res.data
        }
      } catch (e) {
        console.error('获取用户信息失败:', e)
      }
    },
    async getAppList() {
      try {
        const res = await this.$api.market.getAppList()
        if (res.code === 200 && res.data) {
          this.apiKeyCount = res.data.length || 0
        }
      } catch (e) {
        console.error('获取应用列表失败:', e)
      }
    },
    async getExpendList() {
      try {
        const res = await this.$api.order.getOrderList({ type: '2', status: 1 })
        if (res.code === 200 && res.data) {
          const list = res.data.list || res.data || []
          let total = 0
          list.forEach(item => {
            total += parseFloat(item.money) || 0
          })
          this.totalCost = total.toFixed(2)
          
          // 获取今日消耗
          const today = new Date().toLocaleDateString()
          let todayTotal = 0
          list.forEach(item => {
            const itemDate = new Date(item.updatetime).toLocaleDateString()
            if (itemDate === today) {
              todayTotal += parseFloat(item.money) || 0
            }
          })
          this.todayCost = todayTotal.toFixed(2)
        }
      } catch (e) {
        console.error('获取消耗记录失败:', e)
      }
    },
    goRecharge() {
      this.$router.push('/index')
    },
    goApps() {
      this.$router.push('/index/apps')
    },
    goOrder() {
      this.$router.push('/index/order')
    },
    goExpend() {
      this.$router.push('/index/expend')
    },
    goChangeInfo() {
      this.$router.push('/index/ChangeInfo')
    },
    goToExpend() {
      this.$router.push('/index/expend')
    }
  },
  mounted() {
    this.getUserInfo()
    this.getAppList()
    this.getExpendList()
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  padding: 30px;
  background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
  min-height: calc(100vh - 60px);
}

.dashboard-header {
  margin-bottom: 30px;
  
  h2 {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #1a1a2e, #4a4a68);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0 0 8px 0;
  }
  
  p {
    font-size: 14px;
    color: #8a8aa3;
    margin: 0;
  }
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 30px;
}

.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(94, 96, 206, 0.08);
  border: 1px solid rgba(94, 96, 206, 0.08);
  display: flex;
  gap: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 40px rgba(94, 96, 206, 0.15);
    border-color: rgba(94, 96, 206, 0.15);
    
    &::before {
      left: 100%;
    }
  }
  
  .card-icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }
  
  &.today-cost .card-icon {
    background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.1));
    color: #5e60ce;
  }
  
  &.account-balance .card-icon {
    background: linear-gradient(135deg, rgba(46, 196, 182, 0.1), rgba(76, 201, 240, 0.1));
    color: #2ec4b6;
  }
  
  &.api-keys .card-icon {
    background: linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 140, 66, 0.15));
    color: #ff6b35;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      inset: -4px;
      border-radius: 16px;
      background: linear-gradient(135deg, rgba(255, 107, 53, 0.2), transparent);
      animation: pulse 2s ease-in-out infinite;
    }
  }
  
  &.total-cost .card-icon {
    background: linear-gradient(135deg, rgba(147, 129, 255, 0.15), rgba(124, 127, 246, 0.15));
    color: #9381ff;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      inset: -4px;
      border-radius: 16px;
      background: linear-gradient(135deg, rgba(147, 129, 255, 0.2), transparent);
      animation: pulse 2s ease-in-out infinite;
      animation-delay: 0.5s;
    }
  }
  
  @keyframes pulse {
    0%, 100% {
      opacity: 0.5;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.05);
    }
  }
  
  .card-content {
    flex: 1;
    
    .card-label {
      font-size: 14px;
      color: #8a8aa3;
      margin-bottom: 12px;
    }
    
    .card-value {
      display: flex;
      align-items: baseline;
      gap: 4px;
      margin-bottom: 12px;
      
      .currency {
        font-size: 18px;
        color: #4a4a68;
        font-weight: 500;
      }
      
      .amount {
        font-size: 32px;
        font-weight: 700;
        background: linear-gradient(135deg, #1a1a2e, #4a4a68);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }
      
      .unit {
        font-size: 16px;
        color: #8a8aa3;
        margin-left: 4px;
        font-weight: 500;
      }
    }
    
    .card-trend {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      
      .trend-up {
        color: #2ec4b6;
        font-weight: 500;
      }
      
      .trend-down {
        color: #ff6b35;
        font-weight: 500;
      }
      
      .trend-text {
        color: #b0b0c0;
      }
    }
    
    .card-actions {
      button {
        padding: 8px 20px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        border: none;
      }
      
      .btn-recharge {
        background: linear-gradient(135deg, #5e60ce, #7c7ff6);
        color: white;
        box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(94, 96, 206, 0.4);
        }
      }
      
      .btn-manage {
        background: rgba(94, 96, 206, 0.1);
        color: #5e60ce;
        
        &:hover {
          background: rgba(94, 96, 206, 0.15);
        }
      }
    }
  }
}

.dashboard-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.recent-activities {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(248, 249, 252, 0.9));
  border-radius: 20px;
  padding: 28px;
  box-shadow: 
    0 8px 32px rgba(94, 96, 206, 0.1),
    0 0 0 1px rgba(94, 96, 206, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(94, 96, 206, 0.08);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #5e60ce, #2ec4b6, #ff6b35, #9381ff);
    background-size: 200% 100%;
    animation: gradientFlow 3s ease infinite;
  }
  
  @keyframes gradientFlow {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  .activities-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    
    h3 {
      font-size: 20px;
      font-weight: 700;
      background: linear-gradient(135deg, #1a1a2e, #4a4a68);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin: 0;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, #5e60ce, transparent);
        border-radius: 2px;
      }
    }
    
    .view-all {
      font-size: 13px;
      color: #5e60ce;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 6px 14px;
      border-radius: 20px;
      background: rgba(94, 96, 206, 0.08);
      
      &:hover {
        background: rgba(94, 96, 206, 0.15);
        transform: translateX(4px);
      }
    }
  }
  
  .activity-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .activity-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 18px;
    border-radius: 14px;
    background: transparent;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    border: 1px solid transparent;
    
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 14px;
      background: linear-gradient(135deg, rgba(94, 96, 206, 0.03), rgba(46, 196, 182, 0.03));
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    &:hover {
      transform: translateX(8px);
      border-color: rgba(94, 96, 206, 0.1);
      box-shadow: 
        0 4px 20px rgba(94, 96, 206, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
      
      &::before {
        opacity: 1;
      }
      
      .activity-icon {
        transform: scale(1.1) rotate(5deg);
      }
    }
    
    .activity-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: transparent;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      z-index: 1;
      
      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
      }
      
      &.consume {
        background: transparent;
        
        &::after {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 14px;
          background: linear-gradient(135deg, rgba(94, 96, 206, 0.15), transparent);
          z-index: -1;
          animation: iconPulse 2s ease-in-out infinite;
        }
      }
      
      &.recharge {
        background: transparent;
        
        &::after {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 14px;
          background: linear-gradient(135deg, rgba(46, 196, 182, 0.15), transparent);
          z-index: -1;
          animation: iconPulse 2s ease-in-out infinite;
          animation-delay: 0.3s;
        }
      }
      
      &.api {
        background: transparent;
        
        &::after {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 14px;
          background: linear-gradient(135deg, rgba(255, 107, 53, 0.15), transparent);
          z-index: -1;
          animation: iconPulse 2s ease-in-out infinite;
          animation-delay: 0.6s;
        }
      }
    }
    
    @keyframes iconPulse {
      0%, 100% {
        opacity: 0.5;
        transform: scale(1);
      }
      50% {
        opacity: 1;
        transform: scale(1.1);
      }
    }
    
    .activity-content {
      flex: 1;
      position: relative;
      z-index: 1;
      
      .activity-title {
        font-size: 15px;
        color: #1a1a2e;
        font-weight: 600;
        margin-bottom: 6px;
        transition: color 0.3s ease;
      }
      
      .activity-time {
        font-size: 12px;
        color: #8a8aa3;
        display: flex;
        align-items: center;
        gap: 6px;
        
        &::before {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #b0b0c0;
        }
      }
    }
    
    .activity-amount {
      font-size: 15px;
      font-weight: 700;
      position: relative;
      z-index: 1;
      padding: 6px 12px;
      border-radius: 8px;
      transition: all 0.3s ease;
      
      &.consume {
        color: #ff6b35;
        background: rgba(255, 107, 53, 0.08);
      }
      
      &.recharge {
        color: #2ec4b6;
        background: rgba(46, 196, 182, 0.08);
      }
      
      &.api {
        color: #8a8aa3;
        background: transparent;
      }
    }
  }
}

@media (max-width: 768px) {
  .dashboard {
    padding: 20px;
  }
  
  .dashboard-cards {
    grid-template-columns: 1fr;
  }
  
  .quick-actions .action-grid {
    grid-template-columns: 1fr;
  }
}
</style>
